const formatter = new Intl.NumberFormat();

const compactFormatter = new Intl.NumberFormat(undefined, {
    notation: 'compact',
    maximumFractionDigits: 2,
});

/**
 * Format a number in the current locale to be displayed in a chart.
 */
export function formatChartNumber(value: number) {
    return formatter.format(value);
}

/** Abbreviates past a million (`1.46M`). For a tooltip, opened for the value itself. */
export function formatCompactChartNumber(value: number) {
    return formatChartNumberAbove(value, 1_000_000);
}

/** Abbreviates past a thousand (`450K`). For an axis, whose labels are reference marks. */
export function formatChartAxisNumber(value: number) {
    return formatChartNumberAbove(value, 1_000);
}

function formatChartNumberAbove(value: number, threshold: number) {
    return Math.abs(value) >= threshold ? compactFormatter.format(value) : formatter.format(value);
}
